import { Link } from 'react-router-dom';

export default function Article24() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <Link to="/blog" className="inline-block">
            <img 
              src="https://public.readdy.ai/ai/img_res/994872d3-d12a-41a9-b9a3-399c87796801.png" 
              alt="Practical Living Projects" 
              className="h-12 w-auto"
            />
          </Link>
        </div>
      </header>

      {/* Article Content */}
      <article className="max-w-3xl mx-auto px-6 py-16">
        <Link to="/blog" className="inline-flex items-center text-base text-gray-600 hover:text-gray-900 mb-8 transition-colors cursor-pointer whitespace-nowrap">
          ← Back to articles
        </Link>

        <h1 className="text-5xl font-serif font-bold text-gray-900 mb-8 leading-tight">
          TV Installation Considerations for Australian Homes
        </h1>

        <div className="mb-12 overflow-hidden rounded-lg">
          <div className="w-full h-96 relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/4b224c802089655672feb4798912aad0.jpg"
              alt="TV installation in Australian home"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="prose prose-lg max-w-none">
          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Australian homes vary widely in construction style, age, and layout, which influences how TV installations are planned. From older brick homes to modern apartments, each setting presents different considerations.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Wall type, access to power, and room orientation all affect where a TV can be mounted safely and comfortably. Installers also account for ventilation and cable access, ensuring that equipment can be serviced or upgraded in the future.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Climate and household use patterns are additional factors. Secure mounting and quality fixings help installations remain stable despite temperature changes or frequent adjustments.
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-6">
            Documented examples of TV mounting layouts and installation approaches are available at: <a href="https://storage.googleapis.com/tv-wall-mounting-melbourne/tv-wall-mounting-melbourne.html" className="text-gray-900 underline hover:text-gray-600 transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">https://storage.googleapis.com/tv-wall-mounting-melbourne/tv-wall-mounting-melbourne.html</a>
          </p>

          <p className="text-xl text-gray-700 leading-relaxed mb-8">
            For broader guidance on building standards and residential considerations across Victoria, resources from <a href="https://www.building.vic.gov.au/" className="text-gray-900 underline hover:text-gray-600 transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">Building Victoria</a> provide useful context.
          </p>

          <div className="my-12 border border-gray-200 rounded-lg overflow-hidden">
            <iframe 
              src="https://docs.google.com/spreadsheets/d/e/2PACX-1vSsC40U2D6hgtUsq-hZ0KYVA48V6DTVhahTJGpwqHZ4NtHYczWZ6LONwny5Cuy41XRXuSr9rT2nfhDQ/pubhtml?widget=true&amp;headers=false" 
              className="w-full h-96 border-0"
              title="TV Installation Data Reference"
            ></iframe>
          </div>
        </div>
      </article>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-24">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <p className="text-sm text-gray-500 text-center">
            © 2025 Practical Living Projects. <a href="https://readdy.ai/?origin=logo" className="hover:text-gray-700 transition-colors whitespace-nowrap cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </footer>
    </div>
  );
}
